import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

export default class ActionsCellButtonSales extends Component {
  onclickViewDetail = (data) => {
    this.props.context.componentParent.handleActionCellChange(data);
  };

  render() {
    return (
      <div>
        <Button
          className="btn-simple btn btn-warning"
          onClick={() => this.onclickViewDetail(this.props.data)}
        >
          <span style={{ color: 'green' }}>VER MÁS</span>
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CellRenderer/ActionsCellButtonSales.jsx